import React, { useState } from "react";
import { IoCloseOutline } from "react-icons/io5";
import { useDispatch, useSelector } from "react-redux";
import { BsFillQuestionCircleFill } from "react-icons/bs";
import { Numbers, Phone } from "@mui/icons-material";
import { Box, FormControl, Stack, Tooltip } from "@mui/material";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import apiClient from "../../../services/apiClient";

import { closeModal, closeModalWithUpdate } from "../../../features/modal/ModalSlice";
import CustomButton from "../../Button/CustomButton";
import CustomInputBox from "../../Form/CustomInputBox";

const AddRequest = () => {
  const [formData, setFormData] = useState({
    user_id: "",
    company_id: "",
    no_of_phones_required: "",
    extension_start_range: "",
    extension_end_range: "",
    comment: "",
    request_status: "",
  });
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const userInfo = useSelector((state) => state.userInfo.user);

  const handleClosePopup = () => {
    dispatch(closeModal());
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const validate = () => {
    let tempErrors = {};
    if (parseInt(formData.no_of_phones_required) > 2) {
      tempErrors.no_of_phones_required = "You can request maximum up to 2 numbers";
    }
    if (parseInt(formData.extension_start_range) <= 100) {
      tempErrors.extension_start_range = "Extension start range must be greater than 100";
    }
    if (parseInt(formData.extension_start_range) >= parseInt(formData.extension_end_range)) {
      tempErrors.extension_range = "Extension start range must be smaller than extension end range";
    }
    if (
      parseInt(formData.extension_end_range) - parseInt(formData.extension_start_range) + 1 >
      10
    ) {
      tempErrors.extension_range = "You can request a maximum of 10 extensions";
    }
    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;
    setLoading(true);
    try {
      const payload = {
        owner_id: userInfo?.id,
        company_id: userInfo?.company_id,
        company_domain: userInfo?.company_domain,
        no_of_phones_required: parseInt(formData?.no_of_phones_required),
        extension_end_range: parseInt(formData?.extension_end_range),
        extension_start_range: parseInt(formData?.extension_start_range),
        comment: formData?.comment,
        no_extensions_required: formData.extension_end_range - formData.extension_start_range + 1,
        assigned_phone_details: [],
        request_status: "pending",
        request_from: "VOIP",
      };
      await apiClient.post("/requests", payload);

      handleClosePopup();
      toast.success("Requested Send!");
      dispatch(
        closeModalWithUpdate({
          isUpdated: {
            isUpdatedIn: "NEW_REQUEST",
            data: null,
          },
        })
      );
      navigate("/requests");
    } catch (error) {
      toast.error("Oops! Something went wrong please try again");
      console.error("Error saving request:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={"rightModal taskModal"}>
      <div className="modal-header p-3">
        <h4 className="m-0">Add Requests</h4>
        <button className="btnClose ms-auto" onClick={handleClosePopup}>
          <IoCloseOutline />
        </button>
      </div>

      <div className="p-4">
        <Box component="form" onSubmit={handleSubmit}>
          <Stack spacing={2}>
            <FormControl>
              <CustomInputBox
                icon={Phone}
                placeholder="Number of Phones Required"
                label="Numbers"
                name="no_of_phones_required"
                value={formData?.no_of_phones_required}
                onChange={handleChange}
                backgroundColor={"#FFFFFF"}
                error={errors?.no_of_phones_required}
                helperText={
                  errors?.no_of_phones_required || "*You can request maximum up to 2 numbers"
                }
              />
            </FormControl>

            <FormControl>
              <CustomInputBox
                icon={Numbers}
                type="number"
                placeholder="Extension Starting Range i.e 10000"
                label="Extension start"
                name="extension_start_range"
                value={formData?.extension_start_range}
                onChange={handleChange}
                backgroundColor={"#FFFFFF"}
                error={errors?.extension_start_range}
                helperText={errors?.extension_start_range}
              />
            </FormControl>

            <FormControl>
              <CustomInputBox
                icon={Numbers}
                placeholder="Extension Ending Range i.e 10005"
                label="Extension End"
                name="extension_end_range"
                value={formData?.extension_end_range}
                onChange={handleChange}
                backgroundColor={"#FFFFFF"}
                error={errors?.extension_range}
                helperText={
                  errors?.extension_range || "*You can request maximum up to 5 extensions"
                }
              />
            </FormControl>

            <FormControl>
              <CustomInputBox
                // icon={Numbers}
                placeholder="Add Comment here (optional)"
                name="comment"
                value={formData?.comment}
                onChange={handleChange}
                backgroundColor={"#FFFFFF"}
                multiline
                rows={4}
              />
            </FormControl>

            <div class="needHelp text-end">
              Need Help{" "}
              <Tooltip disableFocusListener title="Each extension is mapped to some number.">
                <span className="ms-1">
                  <BsFillQuestionCircleFill />
                </span>
              </Tooltip>
            </div>

            <div className="d-flex justify-content-end gap-3 mt-4">
              <CustomButton
                type="submit"
                variant="contained"
                color="secondary"
                onClick={handleClosePopup}
              >
                Cancel
              </CustomButton>

              <CustomButton type="submit" variant="contained" color="primary" loading={loading}>
                Submit
              </CustomButton>
            </div>
          </Stack>
        </Box>
      </div>
    </div>
  );
};

export default AddRequest;
